import { createFlowchart } from './flowchart';
import { createStateMachine } from './stateMachine';
import { createClassDiagram } from './classDiagram';
import { createMindMap } from './mindMap';
import { createNetworkDiagram } from './network';
import { createOrgChart } from './org';
import { createSchematic, createSchematicSymbolCatalog } from './schematic';
import { createCanNetwork } from './canNetwork';
import { createPipeline, createPipelineSymbolCatalog } from './pipeline';
/** JSON factory dispatcher */
export function createDiagramFromProps(type, props, app) {
    var _a, _b, _c, _d;
    switch (type) {
        case 'flowchart':
            return createFlowchart(app, props.data, props);
        case 'stateMachine':
            return createStateMachine(app, props.data, props);
        case 'classDiagram':
            return createClassDiagram(app, props.data, props);
        case 'mindMap':
            return createMindMap(app, (_a = props.center) !== null && _a !== void 0 ? _a : 'Topic', (_b = props.branches) !== null && _b !== void 0 ? _b : [], props);
        case 'networkTopology':
            return createNetworkDiagram(app, props.data, props);
        case 'orgChart':
            return createOrgChart(app, props.root, props);
        case 'electricalSchematic':
            return createSchematic(app, (_c = props.components) !== null && _c !== void 0 ? _c : [], props);
        case 'schematicSymbolCatalog':
            return createSchematicSymbolCatalog(app, props);
        case 'canNetwork':
            return createCanNetwork(app, props.data, props);
        case 'processPipeline':
            return createPipeline(app, (_d = props.stages) !== null && _d !== void 0 ? _d : [], props);
        case 'pipelineSymbolCatalog':
            return createPipelineSymbolCatalog(app, props);
        default:
            return null;
    }
}
